import { withForm } from '@/core/form/withForm';
import { ImageInput as BaseImageInput } from '@/components/molecules/ImageInput';
import { ImageInputProps } from '@/components/molecules/ImageInput/ImageInput.interface';

export const ImageInput = withForm<ImageInputProps>(BaseImageInput);
